import constants from '../constants';

const initialState = {
  totalOffers: 0,
  offers: [],
  isLoading: false,
  fetchMore: true,
  totalPages: 1,
};

export default function galleryOffersReducer(state = initialState, action) {
  switch (action.type) {
    case constants.SET_GALLERY_OFFERS:
      const { offers, totalOffers } = action.payload;

      // Create a Set of existing offer IDs to prevent duplicates
      const existingOfferIds = new Set(state.offers.map((offer) => offer.id));

      // Filter out any offers that already exist in the state
      const uniqueNewOffers = offers.filter((offer) => !existingOfferIds.has(offer.id));

      return { ...state, offers: [...state.offers, ...uniqueNewOffers], totalOffers };
    case constants.SET_LOADING_OFFERS:
      return { ...state, isLoading: action.payload };
    case constants.SET_FETCH_MORE_GALLERY:
      return { ...state, fetchMore: action.payload };
    case constants.SET_TOTAL_PAGES:
      return { ...state, totalPages: action.payload };
    case constants.CLEAR_OFFERS:
      return { ...state, offers: [], isLoading: true };
    default:
      return state;
  }
}
